import { PlaceholderInspector } from "./PlaceholderInspector"
import type { ControlInspector } from "./types"

export const number: ControlInspector<"number"> = {
  Inspector: ({ field, onEdit }) => (
    <PlaceholderInspector placeholder={field.placeholder} onEdit={onEdit} />
  ),
}
